import React from "react";
import { HelpPanel } from "@cloudscape-design/components";
const DiagramExplorerHelper = () => {
  return /* @__PURE__ */ React.createElement(HelpPanel, { header: /* @__PURE__ */ React.createElement("h2", null, "Manage Diagrams") }, /* @__PURE__ */ React.createElement("p", null, "Choose a Diagram then choose ", /* @__PURE__ */ React.createElement("strong", null, "open"), " to view and edit the AWS Resources on that diagram."));
};
export default DiagramExplorerHelper;
